import React, { FC, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { NavButton } from 'components/Button'
import { StaffPushMessageCardList } from 'components/Card'
import { fetchPushMessages } from 'reducks/pushMessage/operations'
import { getPushMessages } from 'reducks/pushMessage/selectors'

const StaffPushMessageTemplate: FC = () => {
  const dispatch = useDispatch()
  const pushMessages = useSelector((state: State) => getPushMessages(state))

  useEffect(() => {
    dispatch(fetchPushMessages())
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <StaffPushMessageCardList pushMessages={pushMessages} />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default StaffPushMessageTemplate
